$(document).on("turbolinks:load", function () {
  var $reviewEditProductForm = $(".js-productReview-productForm")
  var $reviewEditProductSubmit = $(".js-productReview-productForm-submit")

  $reviewEditProductSubmit.on("click", function (e) {
    e.preventDefault()
    $reviewEditProductForm.trigger("submit")
  })

  $reviewEditProductForm.on("ajax:success", function () {
    swal({
      title: "Product has been saved",
      text: "Click OK to continue reviewing the product.",
      icon: "success",
      buttons: {
        cancel: {
          text: "Cancel",
          value: false,
          visible: false,
          className: "",
          closeModal: true,
        },
        confirm: {
          text: "OK",
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        },
      },
    })
  })

  $reviewEditProductForm.on("ajax:error", function (e, xhr) {
    var errors = JSON.parse(xhr.responseText).errors.join(", ")

    swal({
      title: "Error",
      text: `Product update failed: ${errors}`,
      icon: "error",
      buttons: {
        confirm: {
          text: "OK",
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        },
      },
    })
  })

  // updates the hidden field on product form
  $(".js-product-status").on("change", function () {
    $("#hidden-product-status-field").val($(this).val())
  })
})
